Devuelve scripts activos relacionados con llamadas que pueden adjuntarse a llamadas creadas por la API pública.

<ApiCodeExamples exampleId="scriptsList" />

<ApiResponseExamples exampleId="scriptsList" />

## Alcance obligatorio

- `scripts.read`

## Endpoints

- `GET /public/v1/scripts/`: lista paginada.
- `GET /public/v1/scripts/{id}/`: detalle de un script.

El detalle usa el mismo formato de campos del item de lista.

## Query parameters

- `page` (`integer`, opcional): número de página.
- `page_size` (`integer`, opcional): cantidad de items por página. Default `25`, máximo `100`.
- `search` (`string`, opcional): busca por nombre y descripción.
- `ordering` (`string`, opcional): `name`, `event_type`, `script_type`, `updated_at`, o los mismos campos con prefijo `-`.
- `event_type` (`string`, opcional): filtra por evento.
- `script_type` (`string`, opcional): filtra por tipo de script.

## Campos de respuesta

- `id` (`uuid`): id público del script. Los scripts `pre_call` se envían en `pre_call_script_id`; los demás scripts de llamada se envían en `script_ids`.
- `name` (`string`): nombre del script.
- `description` (`string`): descripción administrativa.
- `event_type` (`string`): evento de llamada que dispara el script.
- `script_type` (`string`): tipo de implementación del script.
- `updated_at` (`datetime`): fecha de última actualización.

## Referencia de opciones

- `event_type`: `pre_call`, `call_started`, `call_completed`, `call_failed`, `call_converted`, `call_optout`.
- `script_type`: `code`, `contact_z_message`.

El catálogo solo expone scripts `pre_call` activos que tienen una política pre-call configurada. Un `pre_call` no debe repetirse en `script_ids`.

La API no expone código, assets internos, historial de ejecución ni configuración interna completa.

## Errores esperados

- `401 Unauthorized`: token inválido, expirado, revocado, ausente o bloqueado por IP.
- `403 Forbidden`: la credencial no tiene `scripts.read`.
- `404 Not Found`: el id del detalle no está disponible para la organización.
- `429 Too Many Requests`: rate limit de la credencial excedido.
